import { put } from "redux-saga/effects";
import axios from "../../config/AxiosConfig";
import { SLIDERS_API } from "../actions/apiCollections";
import { slidersFail, getSlidersSuccess } from "../actions/index";
import { getLanguageId } from "../../helpers/helpers";

export function* getSliders(action) {
	try {
		const response = yield axios.get(SLIDERS_API, {
			params: {
				...(getLanguageId() !== null && {
					language: getLanguageId()
				})
			}
		});
		yield put(getSlidersSuccess(response.data.data.data));
	} catch (error) {
		yield put(slidersFail(error.response));
	}
}
